import React, { useState, useEffect } from 'react'; 
import qs from 'qs';
import server from 'server/serverController2'; 

import Presenter from 'components/presenters/signup/UserDetailCategoryScene';
import ScenePaginationFooter from 'components/presenters/footer/ScenePaginationFooter';

export default function UserDetailCategoryScene({initCategories, parentCategories, currSceneNum, totalSceneNum, onComplete}) {
    const maxSelectNum = 3;
    const [selectedItems, setSelectedItems] = useState([]);
    const [firstCategories, setFirstCategories] = useState([]);
    const [firstCounter, setFirstCounter] = useState(0);
    const [secondCategories, setSecondCategories] = useState([]);
    const [secondCounter, setSecondCounter] = useState(0);
    const [validFooterBtn, setValidFooterBtn] = useState(false); 
    
    /* eslint-disable react-hooks/exhaustive-deps */ 
    useEffect(()=>{
        if(Array.isArray(parentCategories))
        {
            if(parentCategories[0])
            {
                updateCategories(0);
            }
            if(parentCategories[1])
            {
                updateCategories(1);
            }
        }
    },[parentCategories])

    useEffect(()=>{
        if(Array.isArray(initCategories) && initCategories.length > 0)
        {   
            setSelectedItems([]);
            setFirstCounter(0)
            setSecondCounter(0)
            initSetCategories(initCategories.map((item)=>parseInt(item['no'])));
        }
    },[initCategories, firstCategories, secondCategories])

    //Validate
    useEffect(()=>{
        if(parentCategories.length === 2)
        { 
            if(firstCounter > 0 && secondCounter > 0)
            { 
                setValidFooterBtn(true); 
            }
            else 
            { 
                setValidFooterBtn(false); 
            }   
        }
        else if(parentCategories.length === 1)
        { 
            if(firstCounter > 0)
            { 
                setValidFooterBtn(true); 
            }
            else 
            { 
                setValidFooterBtn(false); 
            }   
        }

    },[selectedItems])
    const updateCategories = (categoryIndex)=>{
        let queryString = qs.stringify({order_by:'order', order:'asc',parent_no : parentCategories[categoryIndex]['no'], limit: 100})
        server.getRequestData(`categories?${queryString}`,(res)=>{
            if(res.success !== 1)
            {
                return;
            }
            const jsonData = res.data;
            const categoryList = jsonData['categories'];
            if(categoryIndex === 0)
            {
                setFirstCategories(categoryList) 
            }
            else
            {
                setSecondCategories(categoryList)
            }
        })

    }
    const initSetCategories = (targetNoList) => { 
        let newSelectedItem = [];
        let newFirstCounter = 0;
        let newSecondCounter = 0;
        for(let targetNoIndex = 0; targetNoIndex < targetNoList.length; ++targetNoIndex)
        {
            const targetNo = targetNoList[targetNoIndex]

            for(let i = 0 ; i < firstCategories.length; ++i)
            {
                if(parseInt(firstCategories[i]['no']) === parseInt(targetNo))
                {
                    //if currently selected
                    if(newFirstCounter < maxSelectNum)
                    {
                        newSelectedItem.push(firstCategories[i])
                        ++newFirstCounter;
                    }

                }
            }

            for(let i = 0 ; i < secondCategories.length; ++i)
            {
                if(parseInt(secondCategories[i]['no']) === parseInt(targetNo))
                { 
                    //if currently selected
                    if(newSecondCounter < maxSelectNum)
                    {
                        newSelectedItem.push(secondCategories[i])
                        ++newSecondCounter;
                    }

                }
            } 
        }
        setFirstCounter(newFirstCounter);
        setSecondCounter(newSecondCounter);
        setSelectedItems(newSelectedItem) 
    }

    const handleToggle = (targetNo) => {
        let newSelectedItem = selectedItems.slice();
 
        for(let i = 0 ; i < firstCategories.length; ++i)
        {
            if(parseInt(firstCategories[i]['no']) === parseInt(targetNo))
            { 
                //if currently selected
                if(newSelectedItem.filter((item)=>parseInt(item['no']) === parseInt(targetNo)).length > 0)
                {
                    //remove from list
                    newSelectedItem = newSelectedItem.filter((item)=>parseInt(item['no']) !== parseInt(targetNo))
                    setFirstCounter(firstCounter-1);
                }
                else if(firstCounter < maxSelectNum)
                {
                    newSelectedItem.push(firstCategories[i])
                    setFirstCounter(firstCounter+1);
                }

            }
        }

        for(let i = 0 ; i < secondCategories.length; ++i)
        {
            if(parseInt(secondCategories[i]['no']) === parseInt(targetNo))
            { 
                //if currently selected
                if(newSelectedItem.filter((item)=>parseInt(item['no']) === parseInt(targetNo)).length > 0)
                {
                    //remove from list
                    newSelectedItem = newSelectedItem.filter((item)=>parseInt(item['no']) !== parseInt(targetNo))
                    setSecondCounter(secondCounter - 1);
                }
                else if(secondCounter < maxSelectNum)
                {
                    newSelectedItem.push(secondCategories[i])
                    setSecondCounter(secondCounter + 1);
                }

            }
        } 
        setSelectedItems(newSelectedItem) 
    }
    return ( 
        <div style={{height: '100%', display:'flex', flexDirection:'column'}}>
            <Presenter 
                parentCategories={parentCategories} 
                selectedItems={selectedItems} 
                firstCategories={firstCategories} 
                secondCategories={secondCategories}
                onToggle={handleToggle}
            />
            <ScenePaginationFooter currSceneNum={currSceneNum} totalSceneNum={totalSceneNum}  valid={validFooterBtn} onComplete={()=>{
                onComplete({categories:selectedItems});
            }}/>
        </div>
    );
}

